import React from 'react'
import PropTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'
import { costSourceDisplayValues } from '../../strings/costSourceDisplayValues'
import { useTheme } from '@material-ui/core/styles'

const CostDiagram = ({ sources }) => {
    const theme = useTheme()
    /**
     * Map data from a map to a diagram
     * @return {{datasets: [{backgroundColor: [], data: [], hoverBackgroundColor: string[]}], labels: []}}
     */
    const generateData = () => {
        let data = {
            datasets: [
                {
                    data: [],

                    backgroundColor: [],
                    borderColor: [],
                    hoverBackgroundColor: []
                }
            ],
            labels: []
        }

        Object.entries(sources).forEach(([key, value]) => {
            if (value > 0) {
                const { label, color } = costSourceDisplayValues[key]
                data.labels.push(label)
                const dataset = data.datasets[0]
                dataset.data.push(Number(value.toFixed(2)))
                dataset.backgroundColor.push(color)
                dataset.hoverBackgroundColor.push(color)
                dataset.borderColor.push(color)
            }
        })

        return data
    }

    return (
        <Doughnut
            options={{
                layout: {
                    padding: {
                        top: theme.spacing(2)
                    }
                },
                legend: {
                    labels: {
                        fontColor: theme.palette.text.secondary,
                        fontSize: theme.typography.fontSize
                    },
                    position: 'left',
                    align: 'start'
                },
                tooltips: {}
            }}
            data={generateData()}
        />
    )
}

CostDiagram.propTypes = {
    props: PropTypes.object
}

export default CostDiagram
